import { render, staticRenderFns } from "./VehicleSourceInformationField.vue?vue&type=template&id=218cd186&scoped=true"
import script from "./VehicleSourceInformationField.vue?vue&type=script&lang=ts"
export * from "./VehicleSourceInformationField.vue?vue&type=script&lang=ts"
import style0 from "./VehicleSourceInformationField.vue?vue&type=style&index=0&id=218cd186&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218cd186",
  null
  
)

export default component.exports